import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

setPersistence(auth, browserLocalPersistence).catch(() => {
  /* falls back to in-memory persistence (e.g. private browsing) */
});

export const FIREBASE_PROJECT_ID: string = firebaseConfig.projectId ?? "";
export const FIREBASE_STORAGE_BUCKET: string = firebaseConfig.storageBucket ?? "";

const region = import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION || "europe-west1";
export const FUNCTIONS_BASE_URL: string =
  import.meta.env.VITE_FIREBASE_FUNCTIONS_URL ||
  `https://${region}-${FIREBASE_PROJECT_ID}.cloudfunctions.net`;
